














































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "HNotification"
})

export default class HNotification extends Vue {
  @Prop({ default: undefined }) protected readonly items: Array<{ title: string; outdated: boolean, desc: string, time: string }> | undefined;
  @Prop({ default: false }) protected readonly threeLine!: boolean;
  @Prop({ default: "300" }) protected readonly height!: string;
  @Prop({ default: "No Data" }) protected readonly noDataText!: string;
  @Prop({ default: false }) protected readonly outlined!: boolean;
  @Prop() protected readonly color!: string;
  @Prop() protected readonly headerColor!: string;
  @Prop() protected readonly bodyColor!: string;
  @Prop({ default: false }) protected readonly dark!: boolean;
  @Prop({ default: false }) protected readonly loading!: boolean;
  @Prop({ default: false }) protected readonly hover!: boolean;
  @Prop({ default: false }) protected readonly noScrollbar!: boolean;

  public get itemHeight() {
    return this.threeLine ? "88" : "64";
  }
}
